import HistoricalDisease from "./HistoricalDisease";

export default HistoricalDisease;